import {apiBaseUrl} from '../../../config/env';

export default function getApiBasePath() {
  return localStorage.getItem('cl_api_path') || apiBaseUrl;
}
